module.exports = __webpack_public_path__ + "static/media/wizualizacja-136.904b6ef1.png";